import * as React from "react";
import {
  TextInput,
  Button,
  Grid,
  Title,
  Card,
  Text,
  useMantineTheme,
} from "@mantine/core";
import { Link, useSearchParams } from "react-router-dom";

import { FunctionType } from "@supportinitiative/common";

import { escapeRegExp } from "../utilities";
import { useFunctions } from "../hooks";
import Loading from "../ui/Loading";
import { styles } from "../styles";

function getIsMatch(filter: string) {
  const isMatch = (functionDefinition: FunctionType) => {
    const re = new RegExp(escapeRegExp(filter), "i");
    return (
      re.test(functionDefinition.name) ||
      re.test(functionDefinition.displayName) ||
      re.test(functionDefinition.description)
    );
  };
  return isMatch;
}

export default function Functions() {
  let [searchParams] = useSearchParams();
  let entityId = searchParams.get("entityId");

  let [filter, setFilter] = React.useState("");
  const { data: functions, isLoading } = useFunctions(entityId);
  let [filteredFunctions, setFilteredFunctions] = React.useState<
    FunctionType[]
  >([]);
  const theme = useMantineTheme();

  React.useEffect(() => {
    if (functions) {
      let filteredValues = functions.filter(getIsMatch(filter));
      setFilteredFunctions(filteredValues);
    }
  }, [functions, filter]);

  return (
    <div style={{ marginTop: theme.spacing.lg }}>
      <Title order={3}>Functions</Title>
      <Grid align="center" gutter={"xs"} mb="xs">
        <Grid.Col span={3}>
          <TextInput
            placeholder="Search"
            onChange={(event) => {
              setFilter(event.target.value);
              let filteredValues = functions.filter(
                getIsMatch(event.target.value)
              );
              setFilteredFunctions(filteredValues);
            }}
          />
        </Grid.Col>
        <Grid.Col span={1}>
          <Button
            color="teal"
            styles={() => ({
              root: {
                // margin: "5px",
              },
            })}
            aria-label="New"
            fullWidth
            component={Link}
            to={`/app/functions/new?entityId=${entityId}`}
          >
            New
          </Button>
        </Grid.Col>
      </Grid>

      {isLoading ? (
        <Grid align="center" gutter={"xs"} mb="xs" mt="lg">
          <Grid.Col span={3}>
            <Loading />
          </Grid.Col>
        </Grid>
      ) : (
        <>
          {filteredFunctions.length > 0 ? (
            <Grid align="center" gutter={"xs"} mb="xs">
              {filteredFunctions.map((func) => {
                return (
                  <Grid.Col span={3} key={func.id as unknown as string}>
                    <Card
                      component={Link}
                      to={`/app/functions/edit?id=${func.id}&entityId=${entityId}`}
                      shadow="sm"
                      p="xs"
                      data-testid="function"
                    >
                      <Text fw={500}>{func.name}</Text>
                      <Text
                        size="sm"
                        style={{
                          color: theme.colors.gray[7],
                          lineHeight: 1.5,
                        }}
                      >
                        {func.description}
                      </Text>
                    </Card>
                  </Grid.Col>
                );
              })}
            </Grid>
          ) : (
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                marginTop: "20px",
              }}
            >
              <Text fw={500} style={styles.nodata} data-testid="nodata">
                No Functions
              </Text>
            </div>
          )}
        </>
      )}
    </div>
  );
}
